// src/components/modals/SetViewerModal.jsx
import React from 'react';
import { X, Zap, BookOpen } from 'lucide-react';


export default function SetViewerModal({
  viewingSet,
  onClose,
  onStartPractice,
  onStartChallenge,
  playSound,
  zIndex = 500
}) {
  if (!viewingSet) return null;


  const handleChallenge = () => {
    if (onStartChallenge) onStartChallenge(viewingSet);
    onClose();
    if (playSound) playSound('start');
  };


  const handlePractice = () => {
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };


    const allWords = viewingSet.words || [];
    const limitedWords = shuffleArray(allWords).slice(0, 12);

    onStartPractice({ ...viewingSet, words: limitedWords });
    onClose();
    if (playSound) playSound('start');
  };


  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 animate-in fade-in duration-200"
      style={{ zIndex: 1000 }}
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm" />


      {/* Modal centrado */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={viewingSet.title}
        className="relative w-full max-w-md bg-white rounded-[2rem] shadow-2xl flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200"
        style={{ maxHeight: 'min(85vh, calc(100vh - 140px))' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 px-4 py-4 relative shrink-0">
          <button
            onClick={onClose}
            aria-label="Cerrar"
            className="absolute top-3 right-3 p-1.5 bg-white text-blue-600 rounded-full shadow-md hover:scale-110 active:scale-95 transition-all z-10"
          >
            <X size={18} strokeWidth={3} />
          </button>


          <div className="text-center text-white">
            <div className="text-3xl mb-1 drop-shadow-lg">{viewingSet.emoji}</div>
            <h2 className="text-lg font-black leading-tight px-8">{viewingSet.title}</h2>
            <p className="text-blue-100 text-[10px] font-bold uppercase tracking-widest mt-0.5">
              Guía de Vocabulario
            </p>
          </div>
        </div>


        {/* LISTA */}
        <div className="flex-1 overflow-y-auto px-4 py-3 space-y-2 min-h-0 custom-scrollbar">
          {viewingSet.words?.map((word, idx) => (
            <div
              key={idx}
              className="bg-white p-2.5 rounded-xl border border-slate-100 flex items-center shadow-sm gap-2 hover:border-blue-200 hover:shadow-md transition-all"
            >
              <div className="flex-1 text-left min-w-0">
                <span className="font-bold text-slate-800 text-sm">{word.en}</span>
              </div>


              {word.ipa && (
                <div className="px-1.5 py-0.5 bg-blue-50 rounded-lg border border-blue-100 shrink-0">
                  <span className="font-mono text-[9px] font-bold text-blue-500 uppercase">
                    {word.ipa}
                  </span>
                </div>
              )}


              <div className="flex-1 text-right min-w-0">
                <span className="font-bold text-blue-600 text-sm">{word.es}</span>
              </div>
            </div>
          ))}
        </div>


        {/* FOOTER */}
        <div className="px-4 pt-3 pb-4 bg-white border-t border-slate-100 shrink-0 space-y-2">
          <button
            onClick={handlePractice}
            className="w-full bg-blue-600 text-white py-3 rounded-2xl font-black text-sm shadow-lg shadow-blue-200 hover:bg-blue-500 active:scale-95 transition-all flex items-center justify-center gap-2 border-b-4 border-blue-800 active:border-b-0"
          >
            <Zap fill="currentColor" className="text-yellow-300" size={16} />
            PRACTICAR AHORA
          </button>


          <button
            onClick={handleChallenge}
            className="w-full bg-white text-blue-700 py-3 rounded-2xl font-black text-sm border-2 border-blue-200 hover:border-blue-400 hover:bg-blue-50 active:scale-95 transition-all flex items-center justify-center gap-2"
          >
            ⏱️ DESAFÍO CRONOMETRADO
          </button>


          <button
            onClick={onClose}
            className="w-full bg-slate-100 text-slate-500 py-2.5 rounded-2xl font-black text-xs hover:bg-slate-200 transition-colors flex items-center justify-center gap-2"
          >
            <BookOpen size={14} />
            SOLO LEER
          </button>
        </div>
      </div>
    </div>
  );
}